import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BrowserModule, Title } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/Home/home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PontoBankTransactionDetailComponent } from './pages/transactions/ponto-bank-transactions/ponto-bank-transactions.component';
import { InvoiceDetailComponent } from './pages/transactions/invoice-detail/invoice-detail.component';
import { TransactionAttachmentPopupComponent } from './pages/transactions/invoice-detail/transaction-attachment-popup/transaction-attachment-popup.component';
import { QrcodeComponent } from './pages/transactions/qrcode/qrcode.component';
import { PaymentInputComponent } from './pages/transactions/payment-input/payment-input.component';
import { CounterpartSideDrawComponent } from './pages/transactions/counterpart-detail/counterpart-detail.component';
import { AddCompanyComponent } from './pages/portfolio/portfolio.component';

import {
  ManagementComponent,
  TaskCardComponent,
  TaskDetailsComponent,
} from './pages/management/management.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AceTokenInterceptor } from './core/interceptors/ace-token.interceptor';
import { KeycloakTokenInterceptor } from './core/interceptors/keycloak-token.interceptor';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { ConfigService } from './initializer/config.service';
import { MaterialModule } from './modules/material/material.module';
import {
  MAT_DATE_FORMATS,
  MAT_RIPPLE_GLOBAL_OPTIONS,
  RippleGlobalOptions,
} from '@angular/material/core';
import { PagenotfoundComponent } from './shared/components/pagenotfound/pagenotfound.component';
import { CUSTOM_DATE_FORMATS } from './utils/mat-date-format.util';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DashboardEventsComponent } from './pages/dashboard/dashboard-events/dashboard-events.component';
import { DashboardCalendarWidgetModule } from './pages/dashboard/dashboard-calendar-widget/dashboard-calendar-widget.module';
import { DatePipe } from '@angular/common';
import { FeatureFlagService } from './utils/feature-flag.service';
import { SharedUiModule } from './shared/shared-ui.module';
import { NgxEchartsModule } from 'ngx-echarts';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { translateLoaderFactory } from './modules/i18n/i18n.module';

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
  animation: {
    enterDuration: 300,
    exitDuration: 0,
  },
};
export function storageFactory(): OAuthStorage {
  return localStorage;
}
@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    DashboardEventsComponent,
    HomeComponent,
    ManagementComponent,
    PagenotfoundComponent,
    TaskDetailsComponent,
    TaskCardComponent,
    PontoBankTransactionDetailComponent,
    AddCompanyComponent,
    CounterpartSideDrawComponent,
    InvoiceDetailComponent,
    TransactionAttachmentPopupComponent,
    QrcodeComponent,
    PaymentInputComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [],
        sendAccessToken: false,
      },
    }),
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoaderFactory,
        deps: [HttpClient],
      },
    }),
    SharedUiModule,
    DashboardCalendarWidgetModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
  ],

  providers: [
    Title,
    DatePipe,
    { provide: OAuthStorage, useFactory: storageFactory },
    {
      provide: APP_INITIALIZER,
      useFactory:
        (config: ConfigService, featureFlagService: FeatureFlagService) =>
        () => {
          return config
            .init()
            .then(() => featureFlagService.init())
            .catch(error => {
              console.warn(
                'APP_INITIALIZER: non-critical init error, continuing.',
                error
              );
            });
        },
      deps: [ConfigService, FeatureFlagService],
      multi: true,
    },
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AceTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakTokenInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
